module.exports = __webpack_public_path__ + "img/profile_jf_l1.74a7dea7.jpeg";